/*
  @author       David Gustavsson
  @description  This class stores and handles the mode lto be used as a clear model,
                filling the otherwise empy wholes in the model
*/

import * as THREE from 'three';
import { Material, Mesh } from 'three';
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader';

import { getWebWorkerManager } from '../../workers/web-worker-manager';

export class GLTFClearModel extends THREE.Object3D {
  scanStore: any;

  constructor(scanStore: any) {
    super();

    this.scanStore = scanStore;
  }

  async load(folder: any, modelFile: any) {
    if (!modelFile || typeof modelFile != 'string') {
      console.error('Incorrect clear model format: ', modelFile);
    }

    const clearModelS3URL = await this.scanStore.fetchGltfUrl(modelFile);
    const clearModelData = await getWebWorkerManager().spawnChunkLoader([
      { part: modelFile, s3URL: clearModelS3URL },
    ]);

    const gltfLoader = new GLTFLoader();
    clearModelData.map((chunk: any) => {
      gltfLoader.parse(chunk.data as string, '', (gltf: any) => {
        if (gltf) {
          gltf.scene.rotateX(Math.PI / 2);
          gltf.scene.updateMatrix();

          /**
           * This allows us to support when a a group of meshes define the clear model.
           * Previously only 'Mesh' was supported.
           */
          let children: Mesh[] = [];
          if (gltf.scene.children[0].children[0].type === 'Mesh') {
            children.push(gltf.scene.children[0].children[0] as Mesh);
          } else if (gltf.scene.children[0].children[0].type === 'Group') {
            children = gltf.scene.children[0].children[0].children;
          }

          children.map((child: Mesh) => {
            (child.material as Material).depthWrite = false;
            (child.material as Material).depthTest = true;
            child.geometry.computeVertexNormals();
            this.add(child.clone());
          });
        } else {
          return { error: 'There was an error parsing the gltf chunk.' };
        }
      });
    });
  }
}
